/**
 * Maps a ReportDefinitions ShortCode to the native ClientReportController
 * report code (the {report} route segment / batch string).
 * A ShortCode absent from this map has no on-screen view, download or send.
 * ShortCodes confirmed against dev LeapDb ReportDefinitions rows 2026-07-28.
 */
export const NATIVE_CLIENT_REPORT_CODES: { [shortCode: string]: string } = {
    'ARAP': 'attendance',
    'MILPR': 'milpr',
    'MCPR': 'cohortprogress',
    'PROV': 'progressoverview'
};
